var _radialGradient, _linearGradient, _linearGradient2, _radialGradient2, _linearGradient3, _linearGradient4, _radialGradient3, _linearGradient5, _linearGradient6, _linearGradient7, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGorilla(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 406.911,
    cy: 1366.226,
    gradientTransform: "matrix(.931 0 0 .112 -118.375 312.423)",
    gradientUnits: "userSpaceOnUse",
    r: 263.961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2432,
    stopColor: "#dddbdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6787,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    stopColor: "#fff"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.051,
    x2: 354.798,
    y1: 429.741,
    y2: 458.417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2329,
    stopColor: "#5e6b75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8436,
    stopColor: "#4d5961"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.457,
    x2: 320.076,
    y1: 390.249,
    y2: 314.792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2976,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7716,
    stopColor: "#4b464c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 327.4,
    cy: 277.693,
    gradientTransform: "matrix(.654 .757 -.78 .673 329.853 -157.043)",
    gradientUnits: "userSpaceOnUse",
    r: 97.789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3572,
    stopColor: "#454045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#474247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6335,
    stopColor: "#514c53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8802,
    stopColor: "#544f57"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.985,
    x2: 155.765,
    y1: 441.734,
    y2: 457.693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "#4d5961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#58656e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e6b75"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.844,
    x2: 171.205,
    y1: 376.491,
    y2: 284.839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#645c64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#5b545b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9141,
    stopColor: "#4d474d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: -16.27,
    cy: 247.155,
    gradientTransform: "matrix(1 0 0 .909 0 22.569)",
    gradientUnits: "userSpaceOnUse",
    r: 158.162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4435,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#625a62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#565056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.597,
    x2: 410.343,
    y1: 429.741,
    y2: 458.417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1d5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1363,
    stopColor: "#a1b1be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2643,
    stopColor: "#8995a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3369,
    stopColor: "#808b95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3465,
    stopColor: "#7e8993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5422,
    stopColor: "#636f78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7144,
    stopColor: "#535f67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8436,
    stopColor: "#4d5961"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.413,
    x2: 367.032,
    y1: 372.434,
    y2: 296.977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0038,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5278,
    stopColor: "#59535b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.457,
    x2: 383.457,
    y1: 325.754,
    y2: 453.399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0038,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677,
    stopColor: "#59545c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3149,
    stopColor: "#69636c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#726b75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#756e78"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 246.05,
    cy: 56.791,
    gradientTransform: "matrix(1 0 0 .671 0 18.693)",
    gradientUnits: "userSpaceOnUse",
    r: 361.674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afaab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#867f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3437,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6909,
    stopColor: "#665f69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 115.806,
    cy: 106.397,
    fx: 73.831,
    fy: 193.399,
    gradientTransform: "matrix(.995 .096 -.064 .668 7.389 24.231)",
    gradientUnits: "userSpaceOnUse",
    r: 298.864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0099,
    stopColor: "#a298a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1279,
    stopColor: "#9a909d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4371,
    stopColor: "#857c88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5871,
    stopColor: "#79717c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    stopColor: "#5d5760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 104.001,
    cy: 174.261,
    gradientTransform: "matrix(1 0 0 1.569 0 -99.114)",
    gradientUnits: "userSpaceOnUse",
    r: 54.092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0022,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#756e78"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 327.207,
    cy: 231.601,
    gradientTransform: "matrix(.845 .534 -.423 .669 148.547 -98.141)",
    gradientUnits: "userSpaceOnUse",
    r: 166.151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308,
    stopColor: "#afaab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0418,
    stopColor: "#aba6b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1455,
    stopColor: "#8d8790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#787079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3391,
    stopColor: "#6a636b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4202,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9704,
    stopColor: "#665e66"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.531,
    x2: 211.311,
    y1: 441.734,
    y2: 457.693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4589,
    stopColor: "#4d5961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6628,
    stopColor: "#67727b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8612,
    stopColor: "#79858e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808b95"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.718,
    x2: 222.07,
    y1: 359.379,
    y2: 256.722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3428,
    stopColor: "#716a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7059,
    stopColor: "#645e67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.989,
    x2: 170.989,
    y1: 239.33,
    y2: 446.985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4271,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6917,
    stopColor: "#78717b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8861,
    stopColor: "#817984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b818e"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 96.444,
    cy: 165.69,
    gradientTransform: "matrix(1 0 0 .909 0 15.13)",
    gradientUnits: "userSpaceOnUse",
    r: 158.162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308,
    stopColor: "#afaab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1065,
    stopColor: "#9d98a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2288,
    stopColor: "#87818b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3439,
    stopColor: "#7a737d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4435,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#716a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#655f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 320.775,
    cy: 226.598,
    gradientTransform: "matrix(.845 .534 -.423 .669 145.437 -96.361)",
    gradientUnits: "userSpaceOnUse",
    r: 194.668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729,
    stopColor: "#d0cee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1022,
    stopColor: "#c5c2da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2042,
    stopColor: "#a39fb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3039,
    stopColor: "#898290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3994,
    stopColor: "#756e79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4889,
    stopColor: "#6a626b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    stopColor: "#665e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9704,
    stopColor: "#665e66"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 132.678,
    cy: 161.759,
    gradientTransform: "matrix(.81 .587 -.533 .736 111.426 -35.11)",
    gradientUnits: "userSpaceOnUse",
    r: 157.119
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308,
    stopColor: "#dddaec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0553,
    stopColor: "#d4d1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1794,
    stopColor: "#aba6b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8e8893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3818,
    stopColor: "#7c757f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4435,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#716a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#655f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 22.877,
    cy: 87.603,
    gradientTransform: "matrix(1 0 0 .911 0 7.841)",
    gradientUnits: "userSpaceOnUse",
    r: 34.675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0177,
    stopColor: "#555058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3157,
    stopColor: "#67616a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6327,
    stopColor: "#726b75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#756e78"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 32.284,
    cy: 54.084,
    gradientTransform: "matrix(1 0 0 .911 0 4.841)",
    gradientUnits: "userSpaceOnUse",
    r: 123.214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0cee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1533,
    stopColor: "#aca8bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3078,
    stopColor: "#8e8896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#78717c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5802,
    stopColor: "#6b636c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6795,
    stopColor: "#665e66"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 22.727,
    cy: 110.13,
    gradientTransform: "matrix(1 0 0 1.019 0 -2.035)",
    gradientUnits: "userSpaceOnUse",
    r: 55.225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae7ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2115,
    stopColor: "#c0cdd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5486,
    stopColor: "#9da9b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8235,
    stopColor: "#88939d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808b95"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 10.611,
    cy: 118.69,
    gradientTransform: "matrix(.568 .823 -.839 .578 104.124 41.355)",
    gradientUnits: "userSpaceOnUse",
    r: 65.738
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#dae4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4995,
    stopColor: "#acb7bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8222,
    stopColor: "#8c97a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808b95"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 100.267,
    cy: 144.683,
    gradientTransform: "matrix(1 0 0 1.36 0 -52.149)",
    gradientUnits: "userSpaceOnUse",
    r: 51.959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808b95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#7e8993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7508,
    stopColor: "#77838d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#6c7882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9882,
    stopColor: "#5e6b75"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 119.022,
    cy: 123.933,
    gradientTransform: "matrix(1 0 0 1.569 0 -70.489)",
    gradientUnits: "userSpaceOnUse",
    r: 57.718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5607,
    stopColor: "#736c76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7626,
    stopColor: "#6c666f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9061,
    stopColor: "#615b64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9978,
    stopColor: "#544f57"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_27_",
    cx: 124.994,
    cy: 87.794,
    gradientTransform: "matrix(.995 -.105 .142 1.353 -11.792 -17.934)",
    gradientUnits: "userSpaceOnUse",
    r: 24.651
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0706,
    stopColor: "#808b95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#808b95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    stopColor: "#647079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d5961"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_28_",
    cx: 126.424,
    cy: 115.433,
    gradientTransform: "matrix(.995 -.118 .142 1.531 -15.712 -70.363)",
    gradientUnits: "userSpaceOnUse",
    r: 14.565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d5961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#515d65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#737e88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#808b95"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 496.505c141.385 0 256-14.042 256-31.727h-512c0 17.685 114.615 31.727 256 31.727z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.784 464.778h-118.446c0-16.536 13.405-29.94 29.94-29.94h73.499z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.105 434.838 79.679 29.94v-108.799l-79.679-48.002z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.784 355.979h-.804c-57.868 0-104.779-46.911-104.779-104.779 0-29.156 23.635-52.791 52.791-52.791 29.156 0 52.791 23.636 52.791 52.791v104.779z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.935 426.368h-12.238v38.41h17.687c7.449 0 13.488-6.039 13.488-13.488v-5.985c0-10.459-8.478-18.937-18.937-18.937z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.698 464.778c-31.964-36.629-49.576-83.597-49.576-132.212v-61.804l76.641-83.609v69.71c0 19.441 8.168 37.988 22.51 51.113l-30.686 141.567c-1.927 8.892-9.792 15.235-18.889 15.235z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.122 270.763v-112.55c0-23.976 19.436-43.412 43.412-43.412 23.976 0 43.412 19.436 43.412 43.412v25.726c.001 47.951-38.872 86.824-86.824 86.824z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.329 464.778h-118.445c0-16.536 13.405-29.94 29.94-29.94h73.499z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.651 434.838 79.678 29.94v-108.799l-79.678-48.002z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.263 318.587-17.612-10.61v126.861l17.612 6.618z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.791 76.569 76.428-58.276c5.364-4.09 12.909-3.652 17.764 1.031l67.244 64.871c9.86 9.512 15.429 22.623 15.429 36.322l80.717 36.227c6.01 2.698 13.069 1.296 17.593-3.494 2.932-3.104 7.013-4.864 11.284-4.864h61.734c37.394 0 67.708 30.314 67.708 67.708 0 30.022-20.701 56.08-49.945 62.87l-113.38 26.325c-33.715 7.828-69.113-1.691-94.354-25.374l-43.065-53.101c-33.507-31.437-115.157-150.245-115.157-150.245z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.945 279.916-51.86-48.659c-33.506-31.438-61.449-68.32-82.647-109.084l-23.713-45.604 64.565-49.231-8.307-8.014c-4.854-4.683-12.4-5.121-17.764-1.031l-76.428 58.276 60.333 103.526c13.847 18.29 29.239 35.409 46.028 51.161l51.86 48.659c24.127 22.638 57.534 32.334 89.88 26.309-19.195-3.574-37.284-12.551-51.947-26.308z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.998 123.453-4.805 2.527c-4.874 2.564-7.925 7.617-7.925 13.124v13.861c5.919 9.298 12.209 18.349 18.857 27.129.649-.545 1.278-1.12 1.882-1.725l12.22-12.22c11.04-11.04 17.242-26.014 17.242-41.627v-22.641c0-13.129-5.216-25.72-14.499-35.004-7.805-7.805-20.642-7.167-27.635 1.374l-20.087 24.537c-3.31 4.043-3.576 9.779-.654 14.111l2.669 3.956h19.623c3.691 0 6.683 2.992 6.683 6.683.001 2.482-1.375 4.76-3.571 5.915z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.329 355.979h-.804c-57.868 0-104.779-46.911-104.779-104.779 0-29.156 23.635-52.791 52.791-52.791 29.156 0 52.791 23.636 52.791 52.791v104.779z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.481 426.368h-12.238v38.41h17.687c7.449 0 13.488-6.039 13.488-13.488v-5.985c0-10.459-8.478-18.937-18.937-18.937z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.244 464.778c-31.964-36.629-49.576-83.597-49.576-132.212v-61.804l76.641-83.609v69.71c0 19.441 8.168 37.988 22.51 51.113l-30.686 141.567c-1.927 8.892-9.793 15.235-18.889 15.235z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.28 332.566v-71.451l59.029-54.748v-19.213l-76.641 83.609v61.804c0 48.614 17.612 95.583 49.576 132.212 5.052 0 9.724-1.957 13.21-5.22-29.175-35.819-45.174-80.658-45.174-126.993z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.668 270.763v-112.55c0-23.976 19.436-43.412 43.412-43.412 23.976 0 43.412 19.436 43.412 43.412v25.726c0 47.951-38.872 86.824-86.824 86.824z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.358 251.201c0-26.156 19.022-47.868 43.985-52.06-2.864-.481-5.805-.732-8.806-.732-29.156 0-52.791 23.635-52.791 52.791 0 57.868 46.911 104.779 104.779 104.779h.804v-1.341c-49.877-8.042-87.971-51.291-87.971-103.437z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.28 158.212c0-20.959 14.853-38.448 34.606-42.518-2.844-.586-5.789-.894-8.806-.894-23.976 0-43.412 19.436-43.412 43.412v112.55c6.034 0 11.925-.616 17.612-1.788z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.824 94.255c.129 2.051.792 4.08 1.999 5.87l2.669 3.956 60.205 6.774v-21.066z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.227 54.639h-41.566l.001.012c-5.594-.194-11.238 2.112-15.099 6.828l-20.087 24.535c-1.943 2.373-2.836 5.329-2.653 8.242h64.873z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.395 104.081h-51.903v7.805c0 3.412-1.847 6.556-4.828 8.217l-3.662 2.041c-4.296 2.395-7.606 5.944-9.712 10.075l66.688 6.699z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.29 132.219c-2.884 5.657-3.509 12.405-1.312 18.773l3.635 10.534c3.355 9.724 12.509 16.249 22.796 16.249h36.037l5.533-45.556z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.49 104.081v7.805c0 3.412-1.847 6.556-4.827 8.217l-3.662 2.041c-10.18 5.674-14.825 17.831-11.024 28.847l5.579 16.169c2.192 6.352 8.171 10.615 14.891 10.615h12.923l26.764-77.177-36.981-3.841z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.695 117.75v-22.641c0-13.129-5.215-25.72-14.499-35.004-7.805-7.805-20.642-7.167-27.635 1.374l-20.087 24.535c-3.31 4.043-3.576 9.779-.654 14.111l2.669 3.956h19.623c3.691 0 6.683 2.992 6.683 6.683 0 2.482-1.375 4.759-3.572 5.915l-4.805 2.527c-4.874 2.564-7.925 7.617-7.925 13.124v47.856c7.778 0 15.238-3.09 20.738-8.59l12.22-12.22c11.042-11.04 17.244-26.013 17.244-41.626z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.48 109.174c-3.607 0-6.531-2.924-6.531-6.531v-8.11c0-3.607 2.924-6.531 6.531-6.531 5.506 0 9.969 4.463 9.969 9.969v1.234c0 5.506-4.463 9.969-9.969 9.969z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.848 105.664c-2.131 0-3.859-1.728-3.859-3.859v-6.433c0-2.131 1.728-3.859 3.859-3.859 3.253 0 5.89 2.637 5.89 5.89v2.371c0 3.252-2.637 5.89-5.89 5.89z",
    fill: "url(#SVGID_28_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGorilla);
export default __webpack_public_path__ + "static/media/icon-gorilla.ce4cfa4f875a4cfd9583b23b5ff058c5.svg";
export { ForwardRef as ReactComponent };